const config = require('../../../../../config/locales_json/packs/private/users/delete_account.json');
const language = $('body').data("language");

jQuery(document).ready(function () {
    var deleteAccountForm = $("#user_delete_account_form")
    // Chequeamos que exista el elemento padre para realizar logicas
    if(deleteAccountForm.length > 0){
        $("#user_delete_account_form .save-button").on("click", function(e){
            e.preventDefault()

            var deleteWord = $("#user_delete_account_form #user_password")
            var contDeleteWord = deleteWord.parent();

            if(deleteWord.val() == "delete"){
                const successText = getTranslationValue(config, [language, "successText"],"Eliminando cuenta...")
                $(this).text(successText).addClass("disabled")
                deleteAccountForm.addClass("disabled");
                deleteAccountForm.submit(); 
            } else {
                // Remueve el icono de alerta o success del input
                deleteWord.removeClass("is-invalid");
                deleteWord.removeClass("is-valid");
                // Remueve la clase de has-danger y has-success al contenedor del input
                contDeleteWord.removeClass("has-danger");
                contDeleteWord.removeClass("has-success");
                // Se busca el mensaje de error y lo elimina
                contDeleteWord.find(".fv-plugins-message-container").remove()

                // Mensaje de error
                const errorText = getTranslationValue(config, [language, "error_text"],"Debe ingresar la palabra correspondiente.")
                var errorMsg = '<div class="fv-plugins-message-container"><div class="fv-help-block">'+errorText+'</div></div>';
                // Agrega el icono al input
                deleteWord.addClass("is-invalid");
                // Agrega la clase de has-danger al contenedor del input
                contDeleteWord.addClass("has-danger");
                // Se muestra el mensaje de error
                contDeleteWord.append(errorMsg);
                // Muestro alerta de error
                Swal.fire({
                    text: getTranslationValue(config, [language, "Swalfire_text"], "Lo sentimos!, hemos detectado algunos errores. Por favor revise los datos ingresados."),
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonText: getTranslationValue(config, [language, "Swalfire_confirmButtonText"],"Aceptar"),
                    customClass: {
                        confirmButton: "btn btn-fj-purple"
                    }
                }).then(function () {
                    KTUtil.scrollTop();
                });
            }	
        });
    }
})

function getTranslationValue(config, keys, defaultValue) {
	if (keys.length <= 1) return defaultValue;
  
	let currentTranslation;
	let firstIteration = true;
  
	for (let key of keys) {

	  if (firstIteration) {

      if (config[key]) {
        currentTranslation = config[key];
        firstIteration = false;
      } else {
        firstIteration = false;
        return defaultValue;
      }
	  } else {
      
      if (currentTranslation[key]) {
        currentTranslation = currentTranslation[key];
      } else {
        return defaultValue;
      }
	  }
	}
	
	return currentTranslation;
}